// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"bec2694b","952":"868da8e0"}[chunkId] + ".chunk.js";
};